export default function ControllerIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.1218 4.53926C18.9734 3.7617 18.5404 3.06744 17.9073 2.5922C17.2743 2.11696 16.4867 1.89491 15.6987 1.96947C14.9106 2.04402 14.1787 2.40982 13.646 2.99535C13.1133 3.58088 12.8181 4.34404 12.8182 5.13563H9.18182C9.18189 4.34404 8.88673 3.58088 8.35403 2.99535C7.82133 2.40982 7.0894 2.04402 6.30133 1.96947C5.51326 1.89491 4.72571 2.11696 4.09266 2.5922C3.45961 3.06744 3.02656 3.7617 2.87818 4.53926C2.87818 4.53926 1 13.9429 1 14.2265C1 14.7087 1.19156 15.1712 1.53253 15.5122C1.87351 15.8532 2.33597 16.0447 2.81818 16.0447C3.20002 16.0236 3.56975 15.9032 3.89091 15.6956L9.18182 12.4084H12.8182L18.1091 15.6956C18.426 15.9121 18.7982 16.0332 19.1818 16.0447C19.664 16.0447 20.1265 15.8532 20.4675 15.5122C20.8084 15.1712 21 14.7087 21 14.2265C21 13.9429 19.1218 4.53926 19.1218 4.53926Z"
        stroke="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
